import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import styles from './DeliveryModeModal.module.scss';

const DeliveryModeModal = ({ show, onHide, onConfirm, mode }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className={styles['delivery-mode-modal']}
      backdrop={true}
      size='md'
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirm Delivery Mode Change</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Do you want to stop sending messages to user via {mode?.toUpperCase()}?
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>
          No
        </Button>
        <Button variant='primary' onClick={onConfirm}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeliveryModeModal;
